import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { getBattlebotSlotCenterPixels } from '../components/BattlebotPortalOverlay';
import './QuantumSurgeRefreshEffect.css';

const ATTACK_AGAIN_IMAGE = '/images/attack_again.png';

/**
 * attack_again.png on the targeted unit slot (Quantum Surge — extra attack this turn).
 */
export function QuantumSurgeRefreshEffect({ viewerSlot, animationKey }) {
  const [center, setCenter] = useState(null);

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!viewerSlot?.zone || viewerSlot.index == null) {
        if (!cancelled) setCenter(null);
        return;
      }
      const pt = getBattlebotSlotCenterPixels(viewerSlot.zone, viewerSlot.index);
      if (pt) {
        if (!cancelled) setCenter(pt);
        return;
      }
      if (attempt < 18 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setCenter(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [viewerSlot, animationKey]);

  if (!center) {
    return null;
  }

  const layer = (
    <div
      className="quantum-surge-refresh-root"
      aria-hidden
      data-animation-key={animationKey}
      style={{
        left: `${center.x}px`,
        top: `${center.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <img
        src={ATTACK_AGAIN_IMAGE}
        alt=""
        className="quantum-surge-refresh-image"
        draggable={false}
      />
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default QuantumSurgeRefreshEffect;
